import React from "react"
import { Box } from "@mui/material"

import { AppDialogCancel, AppFormDrawer, AppFormGrid, AppFormSection } from "@components"
import { acrissGroupFormData, isEditAcrissGroupDrawer, isOpenAcrissGroupDrawer } from "Pages/OneWay/AcrissGroups/@signals"
import AcrissGroupDrawerName from "./Name"
import AcrissGroupDrawerAcriss from "./Acriss"
import AcrissGroupDrawerSubmit from "./Submit"


export default function AcrissGroupDrawer() {
	const onClose = () => acrissGroupFormData.value = {}

	return <AppFormDrawer
		icon="layer-group"
		title={isEditAcrissGroupDrawer.value ? 'Edit Acriss Group' : 'New Acriss Group'}
		subtitle="A name and the acriss codes it groups"
		isOpen={isOpenAcrissGroupDrawer.value}
		controller={onClose}
		footer={<>
			<AppDialogCancel onClick={onClose}/>
			<AcrissGroupDrawerSubmit/>
		</>}
	>
		<AppFormSection icon="layer-group" title="Acriss group">
			<AppFormGrid>
				<Box sx={{ gridColumn: 'span 12' }}><AcrissGroupDrawerName/></Box>
				<Box sx={{ gridColumn: 'span 12' }}><AcrissGroupDrawerAcriss/></Box>
			</AppFormGrid>
		</AppFormSection>
	</AppFormDrawer>
}
